<div class="center-content fade-in-animation">
  <div class="report-title">Métricas até o período: {{reports[0]?.date | date:'MM/yy' : 'UTC'}}</div>

  <div class="card">
    <div class="card-content">
      <ngx-datatable class="report-table" [headerHeight]="'auto'" [rowHeight]="28" [columnMode]="columnModes.flex"
        [rows]="groupsRows" [columns]="groupsColumns" [limit]="10">
      </ngx-datatable>
    </div>
  </div>

  <div *ngFor="let group of groupsRows">
    <div class="report-title no-margin">
      <h1>{{group.name}}</h1> Métricas até o período: {{reports[0]?.date | date:'MM/yy' : 'UTC'}}
    </div>

    <div class="report-cards-row">
      <report-card [title]="'Cadastrados'" [value]="formatNumber(group?.registered)" [description]="'Descrição aqui'"
        [icon]="'user'" [iconType]="'feather-icons'"
        [data]="[{ title: 'Aderidos', value: formatNumber(group?.adhered) }, { title: '% de Aderidos', value: group?.adhered_registered }]">
      </report-card>

      <report-card [title]="'Economia Potencial'" [value]="formatCurrency(group?.potentialEconomy) || '-'"
        [description]="'Descrição aqui'" [icon]="'usd'"
        [data]="[{ title: 'Economia lançada', value: formatCurrency(group?.launchedEconomy) || '-' }]">
      </report-card>

      <report-card [title]="'Cupons Gerados'" [value]="formatNumber(group?.coupons)" [description]="'Descrição aqui'"
        [icon]="'ticket'" [data]="[{ title: 'Cinema', value: formatCurrency(group?.cinema_value) || '-' }]">
      </report-card>
    </div>

    <div class="card">
      <div class="card-content">
        <ngx-datatable class="report-table" [headerHeight]="'auto'" [rowHeight]="28" [columnMode]="columnModes.flex"
          [rows]="getGroupTableData(group)" [columns]="detailsGroupColumns">
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>